export const PRODUCT_NAME = 'extraServices'
